const authUserName = state => state.userStore.user ? state.userStore.user.user_name : '';

export default {
  authUserName,
};
